<template>
  <div class="w-100">
    <basic-subheader class="custom__basic-subheader">
      <template v-slot:filters>
        <b-row class="py-4">
          <b-col cols="12" class="d-flex justify-content-between align-items-center">
            <result-tabs :value="value" @input="$emit('input', $event)" />
            <b-dropdown
              class="dropdown-form-filter mr-2"
              no-caret
              right
              ref="dropdownFormFilter"
            >
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
                <span v-if="appliedFilterCount" class="filter-count">{{ appliedFilterCount }}</span>
              </template>
              <h6 class="d-flex align-items-center mb-0 p-4">
                <span class="svg-icon mr-3">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </h6>
              <b-dropdown-divider />
              <b-dropdown-form class="mw-400">
                <b-container class="p-0">
                  <b-row>
                    <b-col>
                      <basic-input
                        label="Khách hàng"
                        placeholder="Nhập tên hoặc số điện thoại"
                        name="keyword"
                        :value.sync="filters.keyword"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <basic-select
                        label="Nhóm"
                        placeholder="--- Chọn nhóm ---"
                        name="onboardGroup"
                        :solid="false"
                        :allowEmpty="true"
                        value-label="text"
                        track-by="value"
                        :options="onboardGroups"
                        :value.sync="filters.onboardGroup"
                        changeValueByObject
                      />
                    </b-col>
                  </b-row>
                  <!-- Chỉ Admin / Manager / Leader mới lọc theo coach; coach khác chỉ thấy khách của mình -->
                  <b-row v-if="canViewAllCustomers">
                    <b-col>
                      <basic-select
                        label="Coach"
                        placeholder="--- Chọn coach ---"
                        name="coach"
                        :solid="false"
                        :allowEmpty="true"
                        value-label="text"
                        track-by="value"
                        :options="coaches"
                        :value.sync="filters.coach"
                        changeValueByObject
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <basic-select
                        label="Chỉ số"
                        placeholder="--- Tất cả chỉ số ---"
                        name="kpiType"
                        :solid="false"
                        :allowEmpty="true"
                        value-label="text"
                        track-by="value"
                        :options="kpiTypes"
                        :value.sync="filters.kpiType"
                        changeValueByObject
                        class="mb-0"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col>
                      <b-form-group label="Nhập từ ngày" class="mb-0">
                        <date-picker
                          placeholder="Từ ngày"
                          input-class="form-control"
                          type="date"
                          format="DD/MM/YYYY"
                          value-type="format"
                          :disabled-date="disabledAfterEndDate"
                          v-model="filters.startDate"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group label="Đến ngày" class="mb-0">
                        <date-picker
                          placeholder="Đến ngày"
                          input-class="form-control"
                          type="date"
                          format="DD/MM/YYYY"
                          value-type="format"
                          :disabled-date="disabledBeforeStartDate"
                          v-model="filters.endDate"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-dropdown-form>
              <b-dropdown-divider />
              <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
                <b-button class="btn ml-2" href="#" tabindex="0" @click="resetRequest">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
                  </span>
                  Reset bộ lọc
                </b-button>
                <b-button class="btn ml-2" href="#" tabindex="0" @click="searchRequest">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                  </span>
                  Lọc dữ liệu
                </b-button>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
    </basic-subheader>
    <Wrapper>
      <template-table
        :column="column"
        :data="data"
        :paging="paging"
        :tableAction="false"
        :selectAction="false"
        :searchAction="false"
      >
        <template v-slot:body="{ item }">
          <td>
            <div>{{ item.fullName }}</div>
            <small class="text-muted">{{ item.username }}</small>
          </td>
          <td>
            {{ item.phoneNumber ? item.phoneNumber.replace('+84', '0') : null }}
          </td>
          <td>{{ item.class }}</td>
          <td>
            <span v-for="name in item.kpiTypes || []" :key="name" class="kpi-badge">{{ name }}</span>
          </td>
          <td class="text-center">{{ item.inputCount }}</td>
          <td>{{ formatDate(item.lastInputAt) }}</td>
          <td style="width: 20px">
            <action-dropdown
              :value="item"
              :show_copy="false"
              :show_view="false"
              :show_edit="false"
              :show_delete="false"
              :boundary="data.length > 2 ? 'scrollParent' : 'window'"
              class="dropdown-form-filter"
            >
              <b-dropdown-text tag="div" class="navi-item cursor-pointer">
                <a class="navi-link cursor-pointer" @click="viewDetail(item)">
                  <span class="menu-icon svg-icon svg-icon-sm">
                    <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/eye.svg" />
                  </span>
                  <span class="navi-text">Xem chi tiết</span>
                </a>
              </b-dropdown-text>
            </action-dropdown>
          </td>
        </template>
      </template-table>
    </Wrapper>
    <modal-kpi-result-detail
      :item="detailItem"
      :kpi-type="appliedRange.kpiType"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import ResultTabs from './ResultTabs.vue';
import canViewAllMixin from '../canViewAllMixin';
import ModalKpiResultDetail from './ModalKpiResultDetail.vue';

export default {
  name: 'KpiResultTab',
  mixins: [canViewAllMixin],
  props: {
    // Tab đang mở, dùng v-model từ trang cha
    value: {
      type: Number,
      default: 0,
    },
    // Bộ lọc dùng chung giữa 2 tab (tên/SĐT, nhóm, khoảng ngày), giữ ở trang cha
    sharedFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    'date-picker': DatePicker,
    'result-tabs': ResultTabs,
    'modal-kpi-result-detail': ModalKpiResultDetail,
  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      column: [
        { key: 'fullName', label: 'Khách hàng', sortable: false, style: { width: '18%' } },
        { key: 'phoneNumber', label: 'SĐT', sortable: false, style: { width: '120px' } },
        { key: 'class', label: 'Nhóm', sortable: false, style: { width: '150px' } },
        { key: 'kpiTypes', label: 'Chỉ số đã nhập', sortable: false },
        { key: 'inputCount', label: 'Số lần nhập', sortable: false, style: { width: '120px' } },
        { key: 'lastInputAt', label: 'Lần nhập gần nhất', sortable: false, style: { width: '170px' } },
        { key: 'action', label: '', sortable: false, style: { width: '20px' } },
      ],
      data: [],
      // Số điều kiện lọc đang áp dụng, hiện trên nút Bộ lọc
      appliedFilterCount: 0,
      detailItem: null,
      // Bộ lọc của lần tải list gần nhất, để modal khớp với list
      appliedRange: { kpiType: null, dateFrom: null, dateTo: null },
      // Lấy sẵn bộ lọc chung từ tab trước, mở tab là áp dụng luôn
      filters: {
        keyword: this.sharedFilters.keyword || null,
        onboardGroup: this.sharedFilters.onboardGroup || null,
        coach: null,
        kpiType: null,
        startDate: this.sharedFilters.startDate || null,
        endDate: this.sharedFilters.endDate || null,
      },
      kpiTypes: [
        { text: 'Đường huyết', value: 'glucose' },
        { text: 'Huyết áp', value: 'bp' },
        { text: 'Cân nặng', value: 'weight' },
        { text: 'Dinh dưỡng', value: 'diet' },
        { text: 'Vận động', value: 'exercise' },
        { text: 'HbA1c', value: 'hba1c' },
      ],
      onboardGroups: [],
      coaches: [],
    };
  },
  computed: {
    searchParams() {
      return {
        keyword: this.filters.keyword || null,
        onboardGroup: this.filters.onboardGroup?.value || null,
        coachId: this.filters.coach?.value || null,
        kpiType: this.filters.kpiType?.value || null,
        // Gửi unix timestamp (giây); "Đến ngày" lấy hết ngày
        dateFrom: this.filters.startDate
          ? this.$moment(this.filters.startDate, 'DD/MM/YYYY').startOf('date').format('X')
          : null,
        dateTo: this.filters.endDate
          ? this.$moment(this.filters.endDate, 'DD/MM/YYYY').endOf('date').format('X')
          : null,
        page: this.paging.page,
        size: this.paging.pageSize,
      };
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.resetPaging();
    },
  },
  created() {
    this.loadData();
    this.getOnboardGroups();
    if (this.canViewAllCustomers) this.getCoaches();
  },
  methods: {
    async loadData() {
      this.$store.commit('context/setLoading', true);
      try {
        const { meta, data, error } = await this.$api.get('/Lesson/KpiResultUsers', {
          params: this.searchParams,
        });
        if (!meta.success) {
          return this.$toastr.e({ title: 'Lỗi !', msg: error.message });
        }
        this.data = data || [];
        this.paging.total = meta.total;
        // Đếm theo điều kiện thực sự gửi lên; khoảng ngày tính là 1
        const params = this.searchParams;
        this.appliedFilterCount = [
          params.keyword,
          params.onboardGroup,
          params.coachId,
          params.kpiType,
          params.dateFrom || params.dateTo,
        ].filter(Boolean).length;
        this.appliedRange = {
          kpiType: this.searchParams.kpiType,
          dateFrom: this.searchParams.dateFrom,
          dateTo: this.searchParams.dateTo,
        };
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async getOnboardGroups() {
      try {
        const { meta, data } = await this.$api.get('CustomerReceives/OnboardGroups');
        if (!meta.success) return;
        // "Khách hàng cá nhân" = khách không có onboard group; BE nhận giá trị __INDIVIDUAL__
        this.onboardGroups = [
          { text: 'Khách hàng cá nhân', value: '__INDIVIDUAL__' },
          ...(data || []).map((name) => ({ text: name, value: name })),
        ];
      } catch {
        // Dropdown lọc hỏng thì thôi, không chặn cả màn
      }
    },
    async getCoaches() {
      try {
        const { data } = await this.$api.get('CustomerReceives/PrepareSearchFormItem');
        this.coaches = (data?.coaches || []).map((c) => ({ text: c.coachName, value: c.coachId }));
      } catch {
        // Dropdown lọc hỏng thì thôi, không chặn cả màn
      }
    },
    disabledAfterEndDate(date) {
      if (!this.filters.endDate) return false;
      return date > this.$moment(this.filters.endDate, 'DD/MM/YYYY').endOf('date').toDate();
    },
    disabledBeforeStartDate(date) {
      if (!this.filters.startDate) return false;
      return date < this.$moment(this.filters.startDate, 'DD/MM/YYYY').startOf('date').toDate();
    },
    viewDetail(item) {
      this.detailItem = item;
      this.$nextTick(() => this.$bvModal.show('modal-kpi-result-detail'));
    },
    // Báo bộ lọc chung lên trang cha để tab kia dùng lại
    emitSharedFilters() {
      const { keyword, onboardGroup, startDate, endDate } = this.filters;
      this.$emit('update:sharedFilters', { keyword, onboardGroup, startDate, endDate });
    },
    searchRequest() {
      this.emitSharedFilters();
      this.resetPaging();
      this.$refs.dropdownFormFilter?.hide();
    },
    resetRequest() {
      this.filters = { keyword: null, onboardGroup: null, coach: null, kpiType: null, startDate: null, endDate: null };
      this.emitSharedFilters();
      this.resetPaging();
    },
    resetPaging() {
      // Đang ở trang khác 1 thì watcher 'paging.page' tự gọi loadData
      if (this.paging.page !== 1) {
        this.paging.page = 1;
        return;
      }
      this.loadData();
    },
    // BE trả DateTime dạng unix timestamp (giây)
    formatDate(value) {
      return value ? this.convertTimestampToDate(value, 'DD/MM/YYYY HH:mm') : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom__basic-subheader {
  display: block;
  justify-content: unset;
  align-items: unset;
}
.mw-400 {
  min-width: 400px;
}
.filter-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 9px;
  background: #01645a;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
}
.kpi-badge {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  margin: 2px 4px 2px 0;
  border-radius: 10px;
  background: #e4f5f5;
  color: #01645a;
  white-space: nowrap;
}
</style>
